import FeatureAnnouncement from './FeatureAnnouncement';

export default FeatureAnnouncement;
